const scriptPromises = {};

const createScriptTag = (src, attributes = {}) => {
  const script = document.createElement('script');
  script.src = src;

  Object.entries(attributes).forEach(([key, value]) => {
    if (value === true) {
      script.setAttribute(key, '');
    } else if (value !== false && value != null) {
      script.setAttribute(key, String(value));
    }
  });

  return script;
};

/**
 * Drop a script that loaded but did not do its job (e.g. a content blocker answered with an empty
 * file), so that the next loadScriptOnce call fetches it again instead of reusing the dud.
 *
 * @param {string} src
 */
export const forgetScript = src => {
  delete scriptPromises[src];
  if (typeof document !== 'undefined') {
    document.querySelectorAll(`script[src="${src}"]`).forEach(script => script.remove());
  }
};

export const loadScriptOnce = (src, attributes = {}) => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error(`Cannot load script on server: ${src}`));
  }

  if (scriptPromises[src]) {
    return scriptPromises[src];
  }

  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    scriptPromises[src] = Promise.resolve(existingScript);
    return scriptPromises[src];
  }

  scriptPromises[src] = new Promise((resolve, reject) => {
    const script = createScriptTag(src, attributes);
    script.onload = () => resolve(script);
    script.onerror = () => {
      // Forget the failure. A cached rejection made every later call fail instantly, so a
      // checkout whose Stripe.js hit a flaky mobile connection could never load it again
      // without a full page reload. The dead tag goes too, or the existingScript branch above
      // would report it as loaded.
      delete scriptPromises[src];
      script.remove();
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.head.appendChild(script);
  });

  return scriptPromises[src];
};
